// Workflow indicator showing progress through import steps
export function WorkflowIndicator({ stage = 'upload', stats = {} }) {
  const stages = [
    { id: 'upload', label: 'Upload', icon: '📤' },
    { id: 'parse', label: 'Parse', icon: '📄' },
    { id: 'triage', label: `Triage${stats.triage_count ? ` (${stats.triage_count})` : ''}`, icon: '🏷️' },
    { id: 'review', label: `Review${stats.review_count ? ` (${stats.review_count})` : ''}`, icon: '👁️' },
    { id: 'approve', label: 'Approve', icon: '✅' },
  ]

  return (
    <div style={{
      display: 'flex',
      gap: 12,
      alignItems: 'center',
      padding: '12px 16px',
      background: '#0f172a',
      borderRadius: 8,
      marginBottom: 16,
      overflowX: 'auto',
    }}>
      {stages.map((s, idx) => {
        const isActive = s.id === stage
        const isDone = stages.findIndex(x => x.id === stage) > idx
        return (
          <div key={s.id} style={{ display: 'flex', alignItems: 'center', gap: 6, whiteSpace: 'nowrap' }}>
            <div style={{
              width: 32,
              height: 32,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: isActive ? '#4f46e5' : isDone ? '#052e16' : '#1e293b',
              color: isActive ? 'white' : isDone ? '#86efac' : '#94a3b8',
              fontWeight: 700,
              fontSize: 14,
            }}>
              {s.icon}
            </div>
            <div style={{
              fontSize: 12,
              color: isActive ? 'white' : isDone ? '#86efac' : '#94a3b8',
              fontWeight: isActive ? 700 : 500,
            }}>
              {s.label}
            </div>
            {idx < stages.length - 1 && (
              <div style={{
                width: 16,
                height: 2,
                background: isDone ? '#86efac' : '#334155',
                margin: '0 4px',
              }} />
            )}
          </div>
        )
      })}
    </div>
  )
}
